// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartlineContainerStyles } from "@awc/App/Components/Cart/CartLineContainer";
import { color, getSystemColor, styledCardStyle, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

cartlineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 114px minmax(400px, 1fr) minmax(92px, 107px);
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        width: 100%;
        background: ${color("common.white")};
        &:not(:last-child) {
            margin-bottom: 14px;
        }
        ${styledCardStyle}

        ${xScreen("lte", "md")} {
            grid-template-columns: 114px minmax(180px, 1fr) minmax(92px, 1fr);
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr minmax(0, 1fr) minmax(0, 1fr) 36px;
        }

        @media print {
            width: 100%;
            content: "";
            display: table;
            clear: both;
            -webkit-column-break-inside: avoid;
            page-break-inside: avoid;
            break-inside: avoid;
            border: 2px solid ${color("common.border")};
            &:before {
                content: none;
            }
        }
    `,
};

cartlineContainerStyles.image = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 4;
        ${xScreen("lte", "sm")} {
            grid-row: 1 / 2;
            grid-column: 1/ 4;
            display: flex;
            justify-content: center;
        }
        @media print {
            min-width: 120px;
            min-height: 120px;
            margin-bottom: 0;
            float: left;
        }
    `,
};

cartlineContainerStyles.description = {
    css: css`
        grid-column: 2 / 4;
        grid-row: 1 / 2;
        position: relative;
        margin-bottom: 0;
        display: flex;
        flex-direction: column;
        padding-right: 50px;

        ${xScreen("lte", "sm")} {
            grid-column: 1/ 5;
            grid-row: 2 / 3;
            padding: 0;
        }
        @media print {
            min-height: 120px;
            display: block;
        }
    `,
};

cartlineContainerStyles.price = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
        }
        @media print {
            float: left;
        }
    `,
};

cartlineContainerStyles.qty = {
    css: css`
        text-align: right;
        grid-column: 3 / 4;
        grid-row: 3 / 4;
        ${xScreen("lte", "sm")} {
            grid-row: 4 / 5;
            grid-column: 3 / 5;
        }
        @media print {
            margin-right: 0;
            min-width: 60%;
            float: left;
        }
    `,
};
cartlineContainerStyles.total = {
    css: css`
        display: flex;
        justify-content: flex-end;
        grid-column: 3 / 4;
        grid-row: 4 / 5;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            grid-row: 5 / 6;
            grid-column: 3 / 5;
        }

        @media print {
            min-width: 60%;
            float: right;
            display: block;
        }
    `,
};
cartlineContainerStyles.remove = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 3;
        display: flex;
        align-items: baseline;
        justify-content: end;
        z-index: 1;
        ${xScreen("lte", "sm")} {
            grid-row: 1 / 2;
            grid-column: 4 / 5;
        }
    `,
};
cartlineContainerStyles.actions = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 3 / 4;
        position: relative;
        display: flex;

        ${xScreen("lte", "sm")} {
            grid-column: 1 / 2;
            grid-row: 4 / 5;
            gap: 12px;
        }

        @media print {
            display: none;
        }

        &:empty {
            display: none;
        }
    `,
};
cartlineContainerStyles.notes = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 4 / 5;
        position: relative;

        &:empty {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            grid-column: 1 / 5;
            grid-row: 6 / 7;
            padding-left: 0;
        }

        @media print {
            min-width: 100%;
            float: left;
        }
    `,
};
